import { inject } from '@angular/core';
import {
  HttpResponse,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

import { LoaderService } from '../../classes/loader/loader.service';
import { Router } from '@angular/router';
import { NotificationsService } from '../../classes/notifications/notifications.service';
import { CredentialsService } from 'src/services/core/credentials/credentials.service';
import { throwError } from 'rxjs';
import { Logger } from 'src/services/core/logger/logger.service';

const log = new Logger('HTTP');

export const HttpErrorInterceptor: HttpInterceptorFn = (request, next) => {
  let errorMessage!: string;
  const loaderService = inject(LoaderService);
  const router = inject(Router);
  const notification = inject(NotificationsService);
  const credentialsService = inject(CredentialsService);

  loaderService.show();

  return next(request).pipe(
    tap((evt) => {
      if (evt && evt instanceof HttpResponse) {
        loaderService.hide();
      }
    }),

    catchError((error: HttpErrorResponse) => {
      loaderService.hide();

      if (error !== null && error && error.error instanceof ErrorEvent) {
        errorMessage = `Error: ${error.error.message}`;
      } else {
        switch (error.status) {
          case 500:
          case 502:
          case 503: {
            errorMessage = 'An internal error occurred.';
            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
          case 400: {
            errorMessage = error.error.message || error.message;
            if (
              errorMessage &&
              // @ts-ignore
              errorMessage['Validation Error'] &&
              // @ts-ignore
              Array.isArray(errorMessage['Validation Error'])
            ) {
              // @ts-ignore
              errorMessage = errorMessage['Validation Error']?.join(', ');
            }

            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
          case 409:
          case 404: {
            errorMessage = error.error.message || error.statusText;
            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
          case 403: {
            notification.publishMessages(
              'You are not authorized for the operation',
              'danger',
              1
            );
            break;
          }
          case 401: {
            // Check if it's a kitchen, bar, or banner limit error
            if (error?.error?.message?.includes('Kitchen limit exceeded') || 
                error?.error?.message?.includes('Bar limit exceeded') ||
                error?.error?.message?.includes('Banner limit exceeded')) {
              errorMessage = error.error.message;
              notification.publishMessages(errorMessage, 'warning', 1);
            } else {
              errorMessage = error.error.message || 'Your session has expired';
              notification.publishMessages(errorMessage, 'danger', 1);
              credentialsService.setCredentials();
              router.navigate(['/auth']);
            }
            break;
          }
          case 0: {
            errorMessage =
              'A connection error occurred. Please, check your network connection';
            notification.publishMessages(errorMessage, 'danger', 1);
            break;
          }
        }
      }

      return throwError(() => error.error);
    })
  );
};
